import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '@env';
import { TRANSLATION_KEYS } from '@shared/constants/translation-keys.const';
import { DevAccountsDrawerComponent } from '@features/web/auth-web/presentation/components/dev-accounts-drawer/dev-accounts-drawer.component';
// Deep path, not the `@shared/ui/patterns` barrel: this is the one `Uv*` component
// rendered outside `@defer`, so importing the barrel here pulls its ~50 sibling exports into the
// eager initial bundle instead of the deferred chunk they'd otherwise tree-shake into.
import { UvCookieConsentBannerComponent } from '@shared/ui/patterns/cookie-consent-banner/cookie-consent-banner.component';
// Same reason as the banner above, plus one of its own: the toast container is the ONLY surface an
// outage on a public page (login, password reset) has, so it cannot wait for a shell to mount it.
import { UvToastComponent } from '@shared/ui/patterns/toast/toast.component';
import { DeveloperContextPanelHostComponent } from './components/developer-context-panel-host/developer-context-panel-host.component';
import { DeveloperFabComponent } from './components/developer-fab/developer-fab.component';
import { FeedbackReportDrawerHostComponent } from './components/feedback-report-drawer-host/feedback-report-drawer-host.component';
import { ProvetRateLimitsPanelHostComponent } from './components/provet-rate-limits-panel-host/provet-rate-limits-panel-host.component';
import { ClientImpersonationPanelHostComponent } from './components/client-impersonation-panel-host/client-impersonation-panel-host.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet, UvCookieConsentBannerComponent, UvToastComponent, DeveloperFabComponent,
    FeedbackReportDrawerHostComponent, DevAccountsDrawerComponent, ProvetRateLimitsPanelHostComponent,
    DeveloperContextPanelHostComponent, ClientImpersonationPanelHostComponent, TranslocoPipe,
  ],
  templateUrl: './web-app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebApp {
  protected readonly showProductionWarning = environment.isLocalProductionAccess;
  protected readonly KEYS = TRANSLATION_KEYS;
}
